import Global from './ab-test-context-global';
import Singular from './ab-test-context-singular';

export default { Global, Singular };
